import { Resources } from 'constants/resources';

import EventNoteIcon from '@mui/icons-material/EventNote';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext } from 'react-admin';
import { Link, LinkProps } from 'react-router-dom';
import {
  ContextMenuButton,
  ContextMenuButtonProps,
} from 'shared/mui/ContextMenu/ContextMenuButton/ContextMenuButton';

export type ContextMenuEntityUserActionsButtonProps = Omit<
  ContextMenuButtonProps,
  'icon' | 'label'
> & {
  entityName?: string;
  entityId?: string;
  linkProps?: Partial<LinkProps>;
};

export const ContextMenuEntityUserActionsButton: React.FC<
  ContextMenuEntityUserActionsButtonProps
> = ({ entityName, entityId, linkProps, ...restProps }) => {
  const translate = useTypedTranslate();

  const record = useRecordContext();

  const { createPathWithQuery } = useCreatePathWithQuery();

  const path = createPathWithQuery(
    {
      resource: Resources.UserActions,
      type: 'list',
    },
    {
      filter: {
        entityId: entityId || record?.originId,
        entityName: [entityName],
      },
    },
  );

  return (
    <Link
      style={{ textDecoration: 'none' }}
      target={linkProps?.target || '_blank'}
      to={path}
      {...linkProps}
    >
      <ContextMenuButton
        icon={<EventNoteIcon fontSize="small" style={{ marginTop: '1px' }} />}
        label={translate('app.buttons.userActions')}
        {...restProps}
      />
    </Link>
  );
};
